// Copyright (c) 2021 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

export const isEmptyOrNull = (str) => {
  const trimStr = str.trim();
  return trimStr === '' || trimStr === null || trimStr === undefined;
};
